import { action as apiAction } from 'api/Api'

type Payload = {
  documentListId: number;
  template: any;
}

const requestAddDocumentTemplate = (payload: Payload) => async () => {
  const { documentListId, template } = payload

  try {
    await apiAction('AddDocumentTemplate', {
      documentsContainerId: documentListId,
      item: template,
    })
  } catch (error) {
    if (error.code !== 300) { // Duplicate
      throw error
    }
  }
}

export default requestAddDocumentTemplate
